// extracted by mini-css-extract-plugin
export default {"inputContainer":"Dropdown_inputContainer__t71ux","icon":"Dropdown_icon__5ngMw"};